import axios from 'axios';
import {getJwtToken} from 'utils/auth/getSession';

import NodeCache from 'node-cache';
const myCache = new NodeCache();

export class Backend {
  async get(path, cache = false, responseType = 'json') {
    let value = cache ? myCache.get(`${path}`) : undefined;
    if (value == undefined) {
      const output = await callLoom(path, 'GET', null, responseType);
      myCache.set(`${path}`, output, 300);
      value = output;
    }
    return value;
  }

  post(path, body) {
    return callLoom(path, 'POST', body);
  }

  put(path, body) {
    return callLoom(path, 'PUT', body);
  }

  delete(path, body) {
    return callLoom(path, 'DELETE', body);
  }
}

export const LOOM_API = process.env.REACT_APP_LOOM_API;

export default new Backend();

const callLoom = async (url, requestMethod, body, responseType) => {
  try {
    const token = await getJwtToken();
    const result = await axios({
      method: requestMethod,
      url,
      data: body,
      headers: {'X-Auth': token},
      responseType,
    });
    return result.data;
  } catch (error) {
    if (error?.response?.data) {
      console.error(
          `Error calling ${url}. Code returned ${error.response.status} and message ${error.response.data.message}`,
      );
      throw error.response.data;
    } else {
      console.error(error.request, error.message);
    }
    throw new Error(`Error calling ${url}.`, error);
  }
};
